import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-logout',
  templateUrl: './icon-logout.component.html',
  styles: []
})
export class IconLogoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
